// extracted by mini-css-extract-plugin
var _1 = "TextareasInline-moduletextareaSkeleton__C8nwn";
var _2 = "TextareasInline-moduletextareaSkeletonBox__I6Pxg";
export { _1 as "textareaSkeleton", _2 as "textareaSkeletonBox" }
